import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState } from 'react';
import { Form, Button, ListGroup, Row, Col } from 'react-bootstrap';

function AssessForm() {
    
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageURL, setSelectedImageURL] = useState(null);
  const [apiResponse, setApiResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0]; 
      setSelectedImage(file); // Store the File object for uploading
  
      // Create a temporary URL for previewing the image
      const imageUrl = URL.createObjectURL(file);
      setSelectedImageURL(imageUrl); 
    }
  };

  const removeImg = (event) => {
    setSelectedImageURL(null);
    setApiResponse(null);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (selectedImage) {
      try {
        setIsLoading(true);
        const formData = new FormData();
        formData.append('image', selectedImage);
        console.log("Sending File...")

        const response = await fetch('http://127.0.0.1:8000/upload-image', {
          method: 'POST',
          body: formData,
        });

        const data = await response.json();
        setApiResponse(data);
        console.log(data);
      } catch (error) {
        console.log('Error');
      } finally {
        setIsLoading(false)
      }
    } 
  };

      return (
        <div className='form-bg'>
          <div className="image-upload-container">
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="formImage" className="mb-3">
                <Form.Label>Upload an Image</Form.Label>
                  <Form.Control type="file" onChange={handleImageChange} />
              </Form.Group>

              {selectedImageURL && (
                <div>
                  <ListGroup>
                    <ListGroup.Item> 
                      <img 
                        alt="Uploaded" 
                        src={selectedImageURL} 
                        style={{ maxWidth: '300px' }} 
                      />
                    </ListGroup.Item>
                  </ListGroup>
                </div>
              )}

              {apiResponse && (
                <div>
                  <h2 style={{textAlign: 'center', margin: '10px'}}>Results</h2>
                  <ListGroup>
                    <ListGroup.Item>
                      <Row> 
                        <Col className='text-center'><span style={{fontWeight: 'bold'}}>BI-RADS Score:</span> {apiResponse.biradscore}</Col> 
                        <Col className='text-center'><span style={{fontWeight: 'bold'}}>Density:</span> {apiResponse.density}</Col> 
                      </Row>
                    </ListGroup.Item>
                  </ListGroup>
                  <h2 style={{textAlign: 'center', margin: '10px'}}>Report</h2>
                  <ListGroup>
                    <ListGroup.Item><span style={{fontWeight: 'bold'}}>Interpretation: </span> <span>{apiResponse.interpretation}</span></ListGroup.Item>
                    <ListGroup.Item><span style={{fontWeight: 'bold'}}>Significance: </span><span>{apiResponse.significance}</span></ListGroup.Item>
                    <ListGroup.Item><span style={{fontWeight: 'bold'}}>Follow-up: </span><span>{apiResponse.followup}</span></ListGroup.Item>
                    <ListGroup.Item><span style={{fontWeight: 'bold'}}>Disclaimer: </span><span>{apiResponse.disclaimer}</span></ListGroup.Item>
                    <ListGroup.Item><span style={{fontWeight: 'bold'}}>Likelihood: </span><span>{apiResponse.likelihood}</span></ListGroup.Item>
                  </ListGroup>
                </div>
              )}

              <div className='buttons-class'>
                <Button id="smbtn" variant="primary" type="submit" disabled={isLoading}>
                  {isLoading ? 'Submitting...' : 'Submit' }
                </Button>
                <Button id="cnbtn" variant="danger" onClick={removeImg}>
                  Cancel
                </Button>
              </div>
            </Form>
    </div>
        </div>
      );
}

export default AssessForm;